export function getSafeInternalRedirect(raw) {
  if (raw == null || raw === "") {
    return null;
  }
  if (typeof raw !== "string") {
    return null;
  }
  if (!raw.startsWith("/") || raw.startsWith("//")) {
    return null;
  }
  return raw;
}

export function pathWithRedirectQuery(pathname, redirectRaw) {
  const safe = getSafeInternalRedirect(redirectRaw);
  if (!safe) {
    return pathname;
  }
  const qs = new URLSearchParams({ redirect: safe }).toString();
  return `${pathname}?${qs}`;
}

export function homePathPreservingReturn(publicHomePath, returnPath) {
  if (!returnPath || returnPath === publicHomePath) {
    return publicHomePath;
  }
  const qs = new URLSearchParams({ redirect: returnPath }).toString();
  return `${publicHomePath}?${qs}`;
}
